/**
 * useCheckoutForm Hook
 * Handle form state management dengan React Hook Form
 */

import { CheckoutValidationSchema } from '@diamond/shared/validation';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, UseFormReturn } from 'react-hook-form';

export interface UseCheckoutFormReturn extends UseFormReturn<any> {
  isFormValid: boolean;
  isDirty: boolean;
}

/**
 * Custom hook untuk manage checkout form state
 *
 * Note: Using `any` type for form data to allow flexible data structure
 * from API (Order type) while still maintaining validation through Yup schema
 *
 * @example
 * const { register, handleSubmit, formState, isFormValid } = useCheckoutForm();
 */
export const useCheckoutForm = (): UseCheckoutFormReturn => {
  const methods = useForm({
    resolver: yupResolver(CheckoutValidationSchema),
    mode: 'onBlur', // Validate on blur
  });

  const { formState } = methods;
  const isFormValid = formState.isValid;
  const isDirty = formState.isDirty;

  return {
    ...methods,
    isFormValid,
    isDirty,
  };
};
